// PenDeFi Faucet Configuration
export const CONFIG = {
  // PenDeFiFaucet contract on Base Sepolia
  FAUCET_ADDRESS: '0x805A82648CfF5b9401C92eE78540dBAa807F98Cf',
  CHAIN_ID: 84532,
  CHAIN_NAME: 'Base Sepolia',
  RPC_URL: 'https://sepolia.base.org',
  EXPLORER_URL: 'https://sepolia.basescan.org',

  // Pentagon Login widget config
  PG_PARTNER_ID: '6',

  // Links
  EXCHANGE_URL: 'https://app-competition.pendefi.com/trade/BTC_USDC',
  LEADERBOARD_URL: 'https://competition.pendefi.com#leaderboard',
  COMPETITION_URL: 'https://competition.pendefi.com',
};

export const FAUCET_ABI = [
  { inputs: [], name: 'claim', outputs: [], stateMutability: 'nonpayable', type: 'function' },
  { inputs: [{ internalType: 'address', name: '', type: 'address' }], name: 'hasClaimed', outputs: [{ internalType: 'bool', name: '', type: 'bool' }], stateMutability: 'view', type: 'function' },
  { inputs: [], name: 'totalClaimants', outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }], stateMutability: 'view', type: 'function' },
  { inputs: [], name: 'btcAmount', outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }], stateMutability: 'view', type: 'function' },
  { inputs: [], name: 'usdcAmount', outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }], stateMutability: 'view', type: 'function' },
  { inputs: [], name: 'paused', outputs: [{ internalType: 'bool', name: '', type: 'bool' }], stateMutability: 'view', type: 'function' },
];
